// extracted by mini-css-extract-plugin
export default {"beautyInsiderForm":"dga-z","errorText":"ega-z"};